































import { useSave } from '@/composables';
import { BaseModuleEditor } from '../base';

export default {
  name: 'MarkerEditor',
  mixins: [BaseModuleEditor],
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  setup(props: any) {
    const { buffer, save } = useSave(props, {
      path: 'model',
    });

    return {
      buffer,
      save,
    };
  },
  computed: {
    library() {
      return [
        { header: this.$t('model.marker.headerMarkers') },
        {
          text: '',
          value: '',
        },
      ];
    },
  },
};
